export default "__VITE_ASSET__DmzjkoZ4__"